enum InvoiceType {
  TM3 = 0,
  Pronto = 1
}

export default InvoiceType;
